import { render, staticRenderFns } from "./budgetChart.vue?vue&type=template&id=284fce17&scoped=true&"
import script from "./budgetChart.vue?vue&type=script&lang=js&"
export * from "./budgetChart.vue?vue&type=script&lang=js&"
import style0 from "./budgetChart.vue?vue&type=style&index=0&id=284fce17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284fce17",
  null
  
)

export default component.exports